import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { globalStyles, noop } from "@client/shared/constants";
import style from "./style";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const TeamSelectorView = ({
  label = "Teams",
  hideNewTeam = false,
  disableNewTeam = false,
  handleChange = noop,
  teams = [],
  placeholder = "Type or select team(s) from dropdown",
  value = "",
  creatingNewTeam = false,
  handleTeamModalClose = noop,
  teamName = "",
  teamUser = [],
  users = [],
  teamIsPublic = true,
  handleFormSubmit = noop,
  handleCreateNewTeam = noop,
  handleTeamChange = noop,
  handleTeamChecked = noop,
  handleTeamName = noop,
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 6,
          marginBottom: 1,
        }}
      >
        <Typography variant="subtitle2">{label}</Typography>
        {!hideNewTeam && (
          <Button
            color="primary"
            disabled={disableNewTeam}
            onClick={() => handleCreateNewTeam()}
            startIcon={<img alt="" src="/assets/plus.svg" />}
            variant="outlined"
          >
            <Typography variant="button" noWrap>
              New Team
            </Typography>
          </Button>
        )}
      </Box>
      <Autocomplete
        size="small"
        getOptionLabel={(option) => option.name}
        // label={label}
        renderInput={(params) => (
          <TextField placeholder={placeholder} {...params} label={label} />
        )}
        onChange={handleChange}
        options={teams}
        value={typeof value === "string" ? [] : value}
        multiple
      />
      <Dialog
        sx={{
          "& .paper": { ...style.teamModalPaper },
        }}
        open={creatingNewTeam}
        onClose={handleTeamModalClose}
      >
        <DialogContent sx={{ minWidth: 600, minHeight: 400 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">Create New RC (Glip) Team</Typography>
            <IconButton>
              <CloseIcon
                sx={{ color: "grey.600" }}
                fontSize="small"
                onClick={handleTeamModalClose}
              />
            </IconButton>
          </Box>
          <Typography sx={{ mt: 4 }} variant="h6">Team Name</Typography>
          <TextField
            size="small"
            placeholder="Enter a name"
            value={teamName}
            onChange={(event) => {
              handleTeamName(event);
            }}
          />
          <Box sx={{ marginTop: 4 }}>
            <Typography variant="subtitle2">
              Select users to add to this Team:
            </Typography>
            <Autocomplete
              size="small"
              label="Users"
              getOptionLabel={(option) => {
                return option.name || "";
              }}
              sx={{ width: "550px" }}
              renderInput={(params) => (
                <TextField
                  placeholder="Type or select user(s) from the dropdown"
                  {...params}
                  label="Users"
                />
              )}
              value={teamUser}
              options={users}
              onChange={(event, values) => {
                handleTeamChange(event, values);
              }}
              multiple
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginTop: "16px",
            }}
          >
            <Switch
              color="secondary"
              // label="Make this Team public?"
              labelProps={{
                classes: {
                  root: "mt-5",
                  label: "color-grey secondary-font pl-1",
                },
              }}
              checked={teamIsPublic}
              onChange={(event) => {
                handleTeamChecked(event);
              }}
            />
            <Typography variant="subtitle2">Make this Team public?</Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTeamModalClose}>
            <Typography variant="body2">Cancel</Typography>
          </Button>
          <Button
            disabled={!(teamName || "").trim()}
            onClick={handleFormSubmit}
            variant="contained"
          >
            <Typography variant="body2">Create Team</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TeamSelectorView;
